import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, Router } from '@angular/router';
import { InProgressComponent } from './in-progress/in-progress.component';
import { ClosedTaskComponent } from './closed-task/closed-task.component';
import { OnHoldComponent } from './on-hold/on-hold.component';
import { SearchService } from '../../../../ui-components/lib/search-field/search.service';
import { FilterDropdownService } from '../../../../ui-components/lib/filter-dropdown/filter-dropdown.service';
import { TabsComponent } from '../../../../ui-components/lib/tabs/tabs.component';
import { TabComponent } from '../../../../ui-components/lib/tabs/tab/tab.component';
import { MyOrganizationService } from '../../../common/services/my-organization/my-organization.service';
import { EMPLOYEE_ROUTES } from '../../../common/constants/employee.routing.constants';
import { MyOrganizationInsight } from '../../../common/models/myorganization-insight.model';
import {
  injectSystemTabsLayout,
  injectFloatingLayout,
  provideSystemTabsLayout,
  injectFloatingPageClasses,
} from '../../../common/helpers/system-tabs-layout/system-tabs-layout';

@Component({
  imports: [
    NgTemplateOutlet,
    TabsComponent,
    TranslocoPipe,
    TabComponent,
    InProgressComponent,
    ClosedTaskComponent,
    OnHoldComponent,
  ],
  templateUrl: './my-organization.component.html',
  styleUrl: './my-organization.component.scss',
  providers: [provideSystemTabsLayout()],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MyOrganizationComponent {
  protected readonly systemTabs = injectSystemTabsLayout();
  protected readonly floating = injectFloatingLayout();
  protected readonly systemTabsPageClasses = injectFloatingPageClasses();
  transloco = inject(TranslocoService);
  myOrganizationService = inject(MyOrganizationService);
  searchService = inject(SearchService);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  filterService = inject(FilterDropdownService);

  insights = signal<MyOrganizationInsight>({
    in_progress_count: 0,
    closed_count: 0,
    on_hold_count: 0,
  });

  actionSourceTabName = signal<string>('');
  myOrganizationTabRoutingParam = EMPLOYEE_ROUTES.MY_ORGANIZATION.TABS;

  constructor() {
    this.getTabsInsight();
  }

  getTabsInsight() {
    this.myOrganizationService.getTabsInsight().subscribe({
      next: (res: any) => {
        this.insights.set(res.data);
      },
    });
  }

  resetSearchAndFilterOnTabChange() {
    this.searchService.clearSearch();
    this.resetFilterOnTabChange();
  }

  resetFilterOnTabChange() {
    this.filterService.resetFiltersAndQueryParams(
      this.router,
      this.activatedRoute
    );
  }
}
